"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_components_button_1 = require("@saatva-bits/pattern-library.components.button");
/**
 * Retrieves the variant URL for the product to build the href
 *
 * @param {object} props
 * @param {string} props.productCode
 * @param {object} props.selectionDeps
 * @param {import('../../typedefs').UseProductState} props.selectionDeps.useProductState
 */
const LearnMoreCTA = ({ productCode, selectionDeps }) => {
    const { useProductState } = selectionDeps;
    const productState = useProductState(productCode, ['variantUrl']);
    const variantUrl = productState && productState.variantUrl;
    if (!variantUrl) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(pattern_library_components_button_1.Button, { kind: "secondary", href: variantUrl, "data-selector": "learnMoreButton", children: "Learn more" }));
};
LearnMoreCTA.propTypes = {
    productCode: prop_types_1.default.string.isRequired,
    selectionDeps: prop_types_1.default.shape({
        useProductState: prop_types_1.default.func.isRequired
    }).isRequired
};
/**
 * Renders all the CTAs configured for a product
 *
 * @param {object} props
 * @param {string} props.productCode
 * @param {string} props.compareCta
 * @param {string} props.shopCta
 * @param {boolean} props.showLearnMoreCta
 * @param {object} props.selectionDeps
 * @param {import('../../typedefs').UseProductState} props.selectionDeps.useProductState
 */
const ProductCTA = ({ compareCta, shopCta, showLearnMoreCta, productCode, selectionDeps }) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [shopCta && ((0, jsx_runtime_1.jsx)(pattern_library_components_button_1.Button, { kind: "primary", href: shopCta, "data-selector": "shopNowButton", children: "Shop now" })), compareCta && ((0, jsx_runtime_1.jsx)(pattern_library_components_button_1.Button, { kind: "secondary", href: compareCta, "data-selector": "compareButton", children: "Compare" })), showLearnMoreCta && (0, jsx_runtime_1.jsx)(LearnMoreCTA, { productCode: productCode, selectionDeps: selectionDeps })] }));
};
ProductCTA.propTypes = {
    compareCta: prop_types_1.default.string,
    shopCta: prop_types_1.default.string,
    showLearnMoreCta: prop_types_1.default.bool,
    productCode: prop_types_1.default.string,
    selectionDeps: prop_types_1.default.shape({
        useProductState: prop_types_1.default.func.isRequired
    }).isRequired
};
exports.default = ProductCTA;
//# sourceMappingURL=ProductCTA.js.map